firebird.controller('unsupportedE2EEncryptionAttendeesCtrl', [
    '$rootScope',
    '$scope',
    'helperService',
    'attendeeListService',
    function ($rootScope, $scope, helperService, attendeeListService) {
        var self = this;

        self.unsupportedAttendees = [];
        self.modalState = 'closed';

        self.cancel = function () {
            self.modalState = 'closed';
            digest();
        };

        self.continueEnableE2EE = function () {
            self.cancel();

            $rootScope.$broadcast('show-modal', 'createE2EEncryptionKey');
        };

        self.hasScrollBar = function () {
            return helperService.hasScrollBar('#unsupportedE2EEncryptionAttendees .attendee-list-container');
        };

        self.getUnsupportedAttendees = function () {
            return self.unsupportedAttendees;
        };

        self.isAttendeeUsingCustomAvatar = function (attendee) {
            if (attendee) {
                return !helperService.isDefaultAvatarUrl(attendee.imageURL);
            }

            return false;
        };

        self.convertContactDataToColorClass = function (id, displayName) {
            return helperService.convertContactDataToColorClass(id, displayName);
        };

        self.getAttendeeInitials = function (attendee) {
            if (attendee && attendee.screenName) {
                return helperService.getInitialsFromName(attendee.screenName);
            }

            return '';
        };

        $scope.$on('show-modal', function (e, modalName) {
            if (modalName === 'unsupportedE2EEncryptionAttendees') {
                resetState();
                self.modalState = 'open';
                digest();
            }
        });

        function resetState() {
            self.unsupportedAttendees = attendeeListService.getAttendeeList().filter(function (attendee) {
                return attendee.isMobileAppUser && !attendee.supportsE2EE;
            });
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
